import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import Select from 'components/Select';

import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg';
import { ControlWithIcon } from 'utils/customComponents';

const DropdownWithIcon = ({
  icon,
  options,
  onChange,
  placeholder,
  className,
  value,
  ...rest
}) => {
  const _value = useMemo(
    () => options.find((item) => item?.value === value?.value),
    [options, value]
  );

  return (
    <div className={`flex justify-start ${className}`}>
      <Select
        {...rest}
        options={options}
        isSearchable={false}
        onChange={onChange}
        components={{
          IndicatorSeparator: () => null,
          Control: ControlWithIcon,
        }}
        className="dropdown-select"
        icon={icon}
        placeholder={placeholder}
        value={_value}
      />
    </div>
  );
};

DropdownWithIcon.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  icon: PropTypes.object,
  className: PropTypes.string,
};
DropdownWithIcon.defaultProps = {
  options: [],
  onChange: () => null,
  placeholder: 'Select action',
  icon: CalendarIcon,
  className: 'lg:w-52 lg:mr-4',
};

export default memo(DropdownWithIcon);
